import { type ReactNode } from 'react';
import { ConditionallyHideWithUrlParam } from '../ConditionallyHideWithUrlParam/ConditionallyHideWithUrlParam';

type Props = {
  children: ReactNode;
};

export const HideOnIOSApp = ({ children }: Props) => {
  return (
    <ConditionallyHideWithUrlParam urlParams={['hs', 'hh', 'hf']}>
      {children}
    </ConditionallyHideWithUrlParam>
  );
};
